/* eslint-disable global-require */

import React, { useState, useEffect } from 'react';
import { Map, TileLayer, ZoomControl } from 'react-leaflet';
import { Stack } from 'grommet';
import L from 'leaflet';

import 'leaflet/dist/leaflet.css';
import MarkerList from '../MarkerList/MarkerList';
import SearchBox from '../SearchBox/SearchBox';
import SearchResults from '../SearchResults/SearchResults';
import InfoBox from '../InfoBox/InfoBox';

import localData from '../../Assets/data.json'; // sample data for local testing
// ----------------------------------------------------------------------------
// fix for marker not appearing
// https://github.com/PaulLeCam/react-leaflet/issues/453#issuecomment-410450387
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
// ----------------------------------------------------------------------------

const cartoDBVoyagerTiles = 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';
const cartoDBVoyagerAttr = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>';
const iconAttr = 'Icons made by <a href="https://www.freepik.com/" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon"/>Flaticon</a> | ';

const local = true;
const dataSource = 'https://church-map.herokuapp.com';

function App(props) {
  const { size } = props;
  // Defaults to center of Durham
  const [center, setCenter] = useState([35.9940, -78.8986]);
  const [zoom, setZoom] = useState(13);
  const [data, setData] = useState([]);
  const [target, setTarget] = useState(0);
  const [infoBoxActive, setInfoBoxActive] = useState(false);

  useEffect(() => {
    if (local) {
      setData(localData);
    } else {
      fetch(`${dataSource}/all`, {
        method: 'GET',
        mode: 'cors',
      })
        .then(response => response.json())
        .then(responseJson => setData(responseJson))
        .then(console.log('Requested Data'))
        .catch((error) => {
          alert("Couldn't access church data: ", error.message);
        });
    }
  }, []);

  useEffect(() => {
    if (target) {
      const targetChurch = data.find(church => church.id === target);
      setCenter([targetChurch.billinglatitude, targetChurch.billinglongitude]);
    }
  }, [data, target]);

  function stackAnchor(s) {
    if (s === 'small') {
      return ('top');
    }
    return ('top-left');
  }

  return (
    <>
      <Stack anchor={stackAnchor(size)}>
        <Map
          center={center}
          zoom={zoom}
          zoomControl={false}
          style={{ zIndex: 0 }}
          onClick={() => setTarget(0)}
        >
          <ZoomControl position="bottomright" />
          <TileLayer
            url={cartoDBVoyagerTiles}
            attribution={iconAttr + cartoDBVoyagerAttr}
          />
          <MarkerList
            data={data}
            target={target}
            setTarget={setTarget}
            setActive={setInfoBoxActive}
          />
        </Map>
        <SearchBox
          data={data}
          size={size}
          target={target}
          setTarget={setTarget}
        />
      </Stack>
      {infoBoxActive && (
      <InfoBox
        dataSource={dataSource}
        active={infoBoxActive}
        setActive={setInfoBoxActive}
        target={target}
      />
      )}
      <SearchResults />
    </>
  );
}

export default App;
